/** WARNING: This file is generated automatically **/

import type { TrackingContextValue } from '../providers/TrackingContext';
import { getEntities } from '../utils/getEntities';
import { getGTMData } from '../utils/getGTMData';
import { trackSelfDescribingEvent } from '../utils/trackSelfDescribingEvent';

/**
 * Fires when user clicks out of non-empty field
 */
export interface InputFill {
  /**
   * name that identifies the field
   */
  fieldName: string;
  /**
   * content of input fields that accept strings
   */
  strInput?: string | null;
  /**
   * content of input fields that accept numbers
   */
  numInput?: number | null;
  /**
   * content of input fields that accept boolean values
   */
  boolInput?: boolean | null;
  /**
   * validation errors
   */
  fieldErrors?: string[] | null;
  /**
   * suggested values
   */
  fieldSuggestions?: string[] | null;
  /**
   * the type of the field
   */
  fieldType:
    | 'checkbox'
    | 'date'
    | 'dropdown'
    | 'number'
    | 'password'
    | 'radio'
    | 'range'
    | 'switch'
    | 'tel'
    | 'text'
    | 'textarea'
    | 'comboList'
    | 'bundleControl'
    | 'listControl';
  /**
   * indicates if the field was auto filled
   */
  isAutoFilled: boolean;
}

export const inputFill = (data: Readonly<InputFill>, context?: TrackingContextValue) => {
  window.__GTM_DATA_LAYER__?.push({ event: 'input_fill', ...data, ...getGTMData(context) });

  trackSelfDescribingEvent(
    {
      event: {
        schema: 'iglu:com.starsgroup/input_fill/jsonschema/3-0-1',
        data
      },
      context: getEntities(context)
    },
    context
  );
};
